import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { handleCompleteLater, handleNext } from './PgEducationPreferenceActions';
import PgEducationPreferenceLayout from './PgEducationPreferenceLayout';
import OutcomeInformationLayout from '../OutcomeInformationLayout';

const PgEducationPreference = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');
    const location = useLocation();
     const outcomeMatch = location.pathname.includes('outcome')
     console.log("outcomeMatch",outcomeMatch)

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: { NEXT: handleNext, I_LL_DO_THIS_LATER: handleCompleteLater, ROUTER_NAVIGATE: navigate, REDIRECT: setRedirectUrl },
    } as any);

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    useEffect(() => {
        data['higherEducationPreferenceInfo'] = data['higherEducationPreferenceInfo'] || {};
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain, routeInfo },
        });
    }, []);
    
    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    const LayoutComponent = outcomeMatch ? OutcomeInformationLayout : PgEducationPreferenceLayout;

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <LayoutComponent> {!state.flags.isDataLoading && <PageBuilder/>}</LayoutComponent>
        </SmartContext.Provider>
    );
};

export default PgEducationPreference;
